import { render, staticRenderFns } from "./ConfirmationCart.vue?vue&type=template&id=b39c3c36&name=component-name"
import script from "./ConfirmationCart.vue?vue&type=script&lang=js"
export * from "./ConfirmationCart.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationCart.vue?vue&type=style&index=0&id=b39c3c36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports